const storeKey = 'app-state-session'

function isValid(session) {
  return session && session.timestamp + session.expire * 1000 > new Date().getTime() + session.span
}

export default {
  get() {
    const str = sessionStorage.getItem(storeKey)
    if (str) {
      return JSON.parse(str)
    }
    return null
  },
  set(session) {
    session.span = session.timestamp - new Date().getTime()
    return sessionStorage.setItem(storeKey, JSON.stringify(session))
  },
  remove() {
    return sessionStorage.removeItem(storeKey)
  },
  // Authorization Header
  getToken() {
    const session = this.get()
    if (!isValid(session)) {
      sessionStorage.removeItem(storeKey)
      return null
    }
    return session.token
  },
  getAccount() {
    const session = this.get()
    if (!isValid(session)) {
      sessionStorage.removeItem(storeKey)
      return null
    }
    return session.account
  }
}



// WEBPACK FOOTER //
// ./src/utils/session.js